import React, { useState, useEffect } from 'react';

import styles from './DropDown.module.scss';
import flagEn from '../../assets/images/flags/flag_en.png';
import flagEs from '../../assets/images/flags/flag_es.png';
import flagDe from '../../assets/images/flags/flag_de.png';
import flagFr from '../../assets/images/flags/flag_fr.png';
import flagBr from '../../assets/images/flags/flag_br.png';
import arrow from '../../assets/images/drop-down-arrow.png';

const FLAGS = [flagEn, flagEs, flagDe, flagFr, flagBr];
const LANGUAGES = ['EN', 'ES', 'DE', 'FR', 'BR'];

const DropDown = ({ currentLanguage, setCurrentLanguage }) => {
    const [currentFlag, setCurrentFlag] = useState(FLAGS[0]);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const index = LANGUAGES.indexOf(currentLanguage);
        const newFlag = FLAGS[index];
        setCurrentFlag(newFlag);
    }, [currentLanguage]);

    return (
        <div className={styles.dropDownWrapper}>
            <div className={`${styles.wrapper} ${isOpen ? styles.opened : ''}`} onClick={() => setIsOpen(!isOpen)}>
                <img className={styles.flag} src={currentFlag} alt={currentLanguage} />
                <div className={styles.language}>{currentLanguage}</div>
                <img src={arrow} className={`${styles.arrow} ${isOpen ? styles.opened : ''}`} alt={''} />
            </div>
            <div className={`${styles.dropDownPart} ${isOpen ? styles.opened : ''}`}>
                {LANGUAGES.map((language, index) => {
                    if (language !== currentLanguage) {
                        return (
                            <div key={index}>
                                <div className={'dividerHorizontal'}></div>
                                <div className={styles.languageItem} onClick={() => { setCurrentLanguage(language); setIsOpen(false); }}>
                                    <img className={styles.flag} src={FLAGS[index]} alt={language}/>
                                    <div className={styles.language}>{language}</div>
                                </div>
                            </div>
                        )
                    }
                })}
            </div>
        </div>
    );
};

export default DropDown;